import { TabStyles } from '@tableau/widgets';
import React from 'react';
import { Messages } from '../../../../codegen/Localize';
import { imgPath } from '../../../../common/utilities/ImgUrl';
import { DialogAlertStyles } from './DialogAlertStyles';

// This will hopefully one day be replaced with shared widgets, but as of 1/27/20
// they don't exist yet.
export interface DialogAlertProps {
  message: string;
  testId: string;
}

export interface InnerDialogAlertProps extends DialogAlertProps {
  iconName: string;
  alertStyle: string;
  altText: string;
  testId: string;
}

const DialogAlert = (props: InnerDialogAlertProps) => (
  <div className={`${DialogAlertStyles.containerStyle} ${props.alertStyle}`} data-tb-test-id={props.testId}>
    <img
      src={imgPath(props.iconName)}
      draggable={false}
      alt={props.altText}
      className={DialogAlertStyles.image}
    />
    <span className={DialogAlertStyles.messageStyle}>{props.message}</span>
  </div>
);

/**
 * Specific Alerts
 */

export const DialogErrorAlert = (props: DialogAlertProps) => (
  <DialogAlert
    testId={props.testId}
    message={props.message}
    iconName={'common_alert_error.svg'}
    alertStyle={DialogAlertStyles.errorStyle}
    altText={Messages.dialogAlert_errorAltText()}
  />
);

export const DialogWarningAlert = (props: DialogAlertProps) => (
  <DialogAlert
    testId={props.testId}
    message={props.message}
    iconName={'common_alert_warning.svg'}
    alertStyle={DialogAlertStyles.warningStyle}
    altText={Messages.dialogAlert_warningAltText()}
  />
);

export const DialogInfoAlert = (props: DialogAlertProps) => (
  <DialogAlert
    testId={props.testId}
    message={props.message}
    iconName={'info_normal.svg'}
    alertStyle={DialogAlertStyles.infoStyle}
    altText={Messages.dialogAlert_warningAltText()}
  />
);

